import HomePage from './pages/HomePage';
import PropertyDetailPage from './pages/PropertyDetailPage';
import BlogPage from './pages/Blog';

export const pages = [
    HomePage,
    PropertyDetailPage,
    BlogPage
];


// WEBPACK FOOTER //
// ./javascript/pages.js